<template>
  <div class="hidden md:flex flex-row justify-start w-full">
    <a :href="phoneLink" class="flex flex-row justify-start items-center space-x-2">
      <div class="flex items-center rounded-full primary-bg text-white p-2">
        <v-icon name="bi-telephone-fill" class="w-5 h-5"></v-icon>
      </div>
      <div class="flex flex-col justify-start items start">
        <p class="text-primary font-bold text-sm uppercase">Contact us</p>
        <p class="font-bold phone-number m-0 text-xl">{{ phoneNumber }}</p>
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    phoneNumber: {
      type: String,
      required: true,
      default: '(0044) 28 9433 1941'
    },
    phoneLink: {
      type: String,
      required: true,
      default: 'tel:004428 9433 1941'
    }
  },
})
</script>

<style>
</style>